module.exports = __webpack_public_path__ + "static/media/3_v2.e4dbde45.jpg";